<template>
  <div>
    <b-list-group>
      <b-list-group-item
        v-for="MsgItem in MsgItems" :key="MsgItem.mwct_id"
      >
        <span :class="MsgItem.completed?'read':'unread'">{{MsgItem.type_title}}</span>
        <span>{{MsgItem.msg_body}}</span><br>
        <template v-for="action in MsgItem.action_links">
          <a v-if="MsgItem.is_confirmed==0" :key="action.link_target" href="#merchant" @click="handleAction(action, MsgItem.mwct_id)" style="margin-left:20px;">{{action.link_caption}}</a>
        </template>
        <a href="#merchant" @click="showMore(MsgItem)" style="margin-left:20px;">看詳細</a>
      </b-list-group-item>
    </b-list-group>
    <b-modal
      id="msgDetail" 
      ref="modalView"
      v-model="modalDetailShow"
      :static="true"
      centered
      hide-header
      hide-footer
    >
      <!--難看難用,還是改用populate-form比較方便,晚點再改-->
      <div style="text-align:left;">
        <span>訊息類型:{{detailData.msg_title}}</span><br>
        <span>訊息時間:{{detailData.msg_time}}</span><br>
        <span>訊息內容:{{detailData.msg_body}}</span><br>
        <span>是否已確認：{{detailData.is_confirmed?'是':'否'}}</span><br>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'MyMsgList',
  data: function () {
    return {
      showMsg: false,
      displayingMsg: '',
      popupReadId: -1,
      modalDetailShow: false,
      detailData:{},
    }
  },
  props: [
      'MsgItems',
    ],
  methods: {
    showMore(item) {
      // console.log(item)
      this.detailData = item
      this.modalDetailShow = true

    },
    handleAction(action, mwct_id) {
      // console.log(mwct_id)
      // 根據action.link_target決定要做什麼
      // 然後把link_param與param_value pass給實際處理的程式段使用
      switch (action.link_target) {
        case 'confirm_apply':
          alert('process '+action.link_target+' with '+action.link_param+':'+action.param_value)
          this.setRead(mwct_id)
          break
        case 'reject_apply':
          alert('process '+action.link_target+' with '+action.link_param+':'+action.param_value)
          break
        default:
          alert(action.link_target+'未被定義')
          break
      }
    },
    loadMsg: function () {
      alert('load msg')
    },
    cancel: function () {
      this.CancelCallback();
    },
    PopupDisplay: function (msg) {
      // 不使用,點擊的互動就透過action_links做render
      this.displayingMsg = msg.msg_body
      this.popupReadId = msg.mwct_id
      this.$refs.modalConfirm.show()
      this.showMsg = true;
    },
    confirmReadMsg() {
      // 這個現在會失敗正常,因為那個api是給會員使用的,店家確認訊息的api還沒寫(type_for_id不是一個帳號而是供應商或店家,確認機制較複雜還沒設計)
      // 應該也不需要使用,有知道了的action_link寫在handleAction裡就好,避免狀態因手動單筆更新已完成而不一致(劃位邀請應明確同意或拒絕或改時段建議,不應該只是知道了什麼都不做變已完成)
      let Param = {
        'module':'user_notify_task',
        'method':'confirmTaskNotify',
        'mwct_id': this.popupReadId
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok == 1) {
          // 把那一個item的completed設為1
          vm.setRead(vm.popupReadId)
        }
      },this)
    },
    setRead(mwct_id, read = 1) {
      this.MsgItems.forEach(element => {
        if (element.mwct_id === mwct_id) {
          element.is_confirmed = read
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.unread {
  background-color: aquamarine;
}

</style>
